/**
 * dk-po-number.js
 * Saves the optional "PO Number" field as a cart attribute so it reaches the
 * order. The field is optional — checkout is never blocked.
 *
 *   - Persists the value to the cart attribute `PO Number` (so it survives and
 *     reaches the order even via dynamic checkout buttons).
 *   - Keeps the drawer field and the cart-page field in sync.
 */
(function () {
  if (window.__dkPoNumberInit) return;
  window.__dkPoNumberInit = true;

  var ATTR = 'PO Number';
  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  var saveTimer = null;

  function inputs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-po-number-input]'));
  }

  function syncAll(val) {
    inputs().forEach(function (el) {
      if (el.value !== val) el.value = val;
    });
  }

  function save(val) {
    var attrs = {};
    attrs[ATTR] = val;
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).catch(function () {});
  }

  // Debounced save as the customer types, kept in sync across the drawer and
  // the cart-page copies of the field.
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('[data-po-number-input]')) return;
    var v = el.value;
    syncAll(v);
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () { save(v.trim()); }, 500);
  });

  // Save immediately when the field loses focus.
  document.addEventListener('blur', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('[data-po-number-input]')) return;
    clearTimeout(saveTimer);
    save(el.value.trim());
  }, true);
})();
